import { useEffect, useRef, useState } from "react";

import { InterfaceGraph } from "../interfaces/InterfaceGraph";
import DefaultViewBarchart from "./defaultViewBarChart";
import DefaultViewBarChartMini from "./defaultViewBarChartMini";






const MainCP: React.FC<InterfaceGraph> = (props) => {
    const divRef = useRef(null);

    const { idTipoGraficoProps, nameTitleProps, tituloProps = '', subtitleProps = '', selectValueProsp = [], formatDataStringData = '%', disableFilterProps = false, numDecimalProps = 0, pieTextProps = '', showPieTextInGraph = true, showLineTop = true, showSeries = true, titleY = '', mostrarNegativos = false, mostrarlegend = true, showCategory = true, enableMiniBox = false } = props;

    return (
        <>
            {
                enableMiniBox
                    ?
                    <DefaultViewBarChartMini idTipoGraficoProps={props.idTipoGraficoProps} nameTitleProps={props.nameTitleProps} tituloProps={props.tituloProps} selectValueProsp={props.selectValueProsp} subtitleProps={props.subtitleProps} disableFilterProps={props.disableFilterProps} formatDataStringData={props.formatDataStringData} numDecimalProps={props.numDecimalProps} pieTextProps={props.pieTextProps} titleY={props.titleY} showPieTextInGraph={props.showPieTextInGraph} mostrarNegativos={props.mostrarNegativos} mostrarlegend={props.mostrarlegend} enableMiniBox={props.enableMiniBox} isYAxisActive={props.isYAxisActive} yAxisMax={props.yAxisMax} />
                    :
                    <DefaultViewBarchart idTipoGraficoProps={props.idTipoGraficoProps} nameTitleProps={props.nameTitleProps} tituloProps={props.tituloProps} selectValueProsp={props.selectValueProsp} subtitleProps={props.subtitleProps} disableFilterProps={props.disableFilterProps} formatDataStringData={props.formatDataStringData} numDecimalProps={props.numDecimalProps} pieTextProps={props.pieTextProps} titleY={props.titleY} showPieTextInGraph={props.showPieTextInGraph} mostrarNegativos={props.mostrarNegativos} mostrarlegend={props.mostrarlegend} enableMiniBox={props.enableMiniBox} isYAxisActive={props.isYAxisActive} yAxisMax={props.yAxisMax}   />

            }

        </>
    )
}



export default MainCP;
